import { AfterViewChecked, AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from '../../../services/message-service/message.service';
import { EditHilfeDialogComponent, EditHilfeDialogResult } from '../edit-hilfe-dialog/edit-hilfe-dialog.component';
import { Hilfe, HilfeDialogInput, HilfeDialogResult, HilfeReiter } from '../Hilfe';
import { HilfeService } from '../hilfe.service';
import { CreateTicketDialogComponent } from '../../../components/create-ticket-dialog/create-ticket-dialog.component';

@Component({
    selector: 'kiene-hilfe-dialog',
    templateUrl: './hilfe-dialog.component.html',
    styleUrls: ['./hilfe-dialog.component.scss'],
})
export class HilfeDialogComponent implements OnInit, AfterViewInit, AfterViewChecked {
    @ViewChild('iframeRef') iframe!: ElementRef<HTMLIFrameElement>;
    @ViewChild('matTabGroup') tabGroup!: MatTabGroup;
    public loading: boolean = true;
    public isSaving: boolean = false;
    public isDesktop: boolean;
    public titel: string;
    public hilfe: Hilfe;
    selectedIndex = 0;

    constructor(
        public dialogRef: MatDialogRef<HilfeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: HilfeDialogInput,
        private hilfeService: HilfeService,
        private messageService: MessageService,
        private dialog: MatDialog,
        private sanitizer: DomSanitizer,
    ) {
        if (data?.hilfe) {
            this.hilfe = data.hilfe;
        } else {
            this.messageService.alertMessage('Hilfedaten wurden nicht übergeben!');
        }
    }

    ngOnInit(): void {
        this.isDesktop = this.data?.hilfe?.projekt === 'desktop';

        if (this.hilfe.hilfe_reiter.length > 0) {
            const ersterReiter = this.hilfe.hilfe_reiter[0];
            if (ersterReiter && ersterReiter.hilfeseite_url) {
                ersterReiter.sichereUrl = this.sanitizer.bypassSecurityTrustResourceUrl(ersterReiter.hilfeseite_url);
                ersterReiter.showIframe = true;
            }
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            if (this.tabGroup) {
                this.tabGroup.selectedIndex = 0;
            }
        }, 0);
        if (this.iframe && this.iframe.nativeElement) {
            this.iframe.nativeElement.addEventListener('load', () => {
                this.loading = false;
            });

            this.iframe.nativeElement.addEventListener('error', () => {
                this.loading = false;
            });
        }
    }

    ngAfterViewChecked(): void {
        // Keine Aktion erforderlich
    }

    public createHilfereiter(): void {
        const neuerReiter = new HilfeReiter();
        neuerReiter.titel = 'Neuer Reiter';
        neuerReiter.hilfeseite_url = '';
        neuerReiter.benutzerrollen = [];
        neuerReiter.sichereUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
        neuerReiter.showIframe = false;

        const dialogRef = this.dialog.open(EditHilfeDialogComponent, { width: '500px', data: neuerReiter });

        dialogRef.afterClosed().subscribe((result: EditHilfeDialogResult) => {
            if (result && result.confirm) {
                this.hilfe.hilfe_reiter.push(result.hilfeReiter);

                setTimeout(() => {
                    if (this.tabGroup) {
                        this.tabGroup.selectedIndex = this.hilfe.hilfe_reiter.length - 1;
                    }
                }, 50);
            }
        });
    }

    public updateHilfereiter(): void {
        const reiter = this.hilfe.hilfe_reiter[this.selectedIndex];

        const dialogRef = this.dialog.open(EditHilfeDialogComponent, { width: '500px', data: reiter });

        dialogRef.afterClosed().subscribe((result: EditHilfeDialogResult) => {
            if (result && result.confirm) {
                if (result.hilfeReiter === undefined) {
                    this.hilfe.hilfe_reiter.splice(this.selectedIndex, 1);

                    if (this.hilfe.hilfe_reiter.length === 0) {
                        this.selectedIndex = 0;
                    } else {
                        if (this.selectedIndex >= this.hilfe.hilfe_reiter.length) {
                            this.selectedIndex = this.hilfe.hilfe_reiter.length - 1;
                        }
                        if (this.selectedIndex < 0) {
                            this.selectedIndex = 0;
                        }
                    }
                } else {
                    this.hilfe.hilfe_reiter[this.selectedIndex] = result.hilfeReiter;
                }

                setTimeout(() => {
                    if (this.tabGroup && this.hilfe.hilfe_reiter.length > 0) {
                        this.tabGroup.selectedIndex = this.selectedIndex;
                    }
                }, 0);
            }
        });
    }

    public save(): void {
        this.isSaving = true;

        this.hilfeService.updateHilfe(this.hilfe).subscribe({
            next: (response: Hilfe) => {
                this.isSaving = false;
                this.messageService.infoMessage('Hilfe erfolgreich gespeichert.');
                const hilfeResult = new HilfeDialogResult();
                hilfeResult.hilfe = response;
                hilfeResult.confirm = true;
                this.dialogRef.close(hilfeResult);
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Hilfe konnte nicht gespeichert werden!', error);
            },
        });
    }

    public isDisabled(): boolean {
        return this.hilfe.hilfe_reiter.length === 0;
    }

    public onTabChange(event: MatTabChangeEvent): void {
        this.selectedIndex = event.index;
        const reiter = this.hilfe.hilfe_reiter[this.selectedIndex];

        if (reiter && reiter.hilfeseite_url) {
            reiter.sichereUrl = this.sanitizer.bypassSecurityTrustResourceUrl(reiter.hilfeseite_url);
            reiter.showIframe = true;
        }
    }

    openTicketDialog() {
        this.dialog.open(CreateTicketDialogComponent, { width: '100%', data: undefined });
    }
}
